import { useState } from '@max/max';
const isWeb = true;
import { AntiReqTool } from '@nibfe/h5guard-request';
import { useMonitorEngineContext } from '@nibfe/mcp-monitor-sdk';
import { request as maxRequest } from '@max/meituan-uni-network';
import { getAppVersion, PlatformType } from '@nibfe/mkt-env-api';
// import { API_PATH, INVALID_CODES, PLAY_TYPE } from '@/types/shared';
import { getRiskParams } from '@nibfe/mkt-risk-api';
// import { mock_user } from './mock';
import { getPlatformType } from '@nibfe/mkt-env-api';
import { getSystemInfoSync } from '@max/meituan-uni-system';
export const AJAX_ERROR_NAME = '网络错误';
const API_MAP = {
    PROD: 'https://ihotel.meituan.com',
    TEST: 'https://api.hotel.test.meituan.com',
    SL: 'https://chenzhuo24-wnyvb-sl-api.hotel.test.meituan.com',
    MOCK: "http://local.meituan.com:7718",
    PAPI_MOCK: "https://papi.sankuai.com/api/req/c80c3278-f278-493d-b8c1-4f8048562846"
};
var API_PATH;
(function (API_PATH) {
    // 3.9 周边游城市推荐
    API_PATH["RECOMMEND_CITIES"] = "/api/altas/marketing/recommend/cities";
    // 3.10 城市体验信息查询
    API_PATH["QUERY_PLAY_CONTENT"] = "/api/altas/marketing/content/query";
})(API_PATH || (API_PATH = {}));
const INVALID_CODES = [];
export { API_PATH };
const handleParams = (params = {}) => {
    return Object.keys(params ?? {}).map((key, index) => {
        const value = params[key];
        if (!params[key]) {
            return;
        }
        if (index === 0) {
            return value ? `?${key}=${value}` : '';
        }
        else {
            return value ? `&${key}=${value}` : '';
        }
    }).join('');
};
export function useRequest(path, options) {
    const { raw = false, method = 'POST' } = options || {};
    const ctx = useMonitorEngineContext();
    const [requestStatus, setRequestStatus] = useState(RequestStatus.SUCCESS);
    const request = async (params) => {
        try {
            const { uuid, platform, userId, token, lat, lng } = ctx._runtimeInfo.commonParams;
            setRequestStatus(RequestStatus.LOADING);
            let finalRequestParams = {
                ...params,
                userId
            };
            if (true) {
                try {
                    const antiReq = new AntiReqTool({
                        autoFillParams: true
                    });
                    // @ts-ignore
                    finalRequestParams = antiReq.addCommonParams(finalRequestParams);
                }
                catch {
                    ctx._raptorReport.monitorReportLog('请求加上反爬参数错误', '请求加上反爬参数错误', {
                        level: 'warn',
                        category: 'jsError'
                    });
                }
            }
            let riskParams = {};
            try {
                riskParams = await getRiskParams(/** 风险标识-酒店 */ 2);
            }
            catch (e) {
                // empty
            }
            const version = getAppVersion();
            const riskRequest = {
                ...riskParams,
                uuid,
                version,
                expoId: ctx._runtimeInfo.queryParams.expoId || '',
                latitude: Number.isNaN(Number(lat)) ? 0 : Number(lat),
                longitude: Number.isNaN(Number(lng)) ? 0 : Number(lng)
            };
            if (isWeb && Boolean(ctx?._runtimeInfo?.queryParams?.isPtest)) {
                // @ts-expect-error
                finalRequestParams.isPtest = true;
            }
            const response = await new Promise((resolve, reject) => {
                const url = API_MAP.PROD;
                // const url = API_MAP.TEST;
                // const url = API_MAP.SL;
                // const url = API_MAP.PAPI_MOCK;
                maxRequest({
                    url: `${url}${path}${handleParams(finalRequestParams)}`,
                    data: {
                        ...finalRequestParams,
                        riskRequest,
                        userId: Number(userId),
                        token,
                        platform: platform === 'dp' ? 2 : 1,
                        source: getSource(),
                        osType: getOSType(),
                        // pageSource: ctx._runtimeInfo.queryParams.pageSource || '',
                        cityId: Number(ctx._runtimeInfo.cityId) || 0,
                        latitude: Number.isNaN(Number(lat)) ? 0 : Number(lat),
                        longitude: Number.isNaN(Number(lng)) ? 0 : Number(lng),
                        uuid,
                        version
                    },
                    method,
                    header: {
                        'content-type': 'application/json',
                        token
                    },
                    _meituan: {
                        requestType: 'MRNUtils',
                        mrnChannel: 'hotel',
                        params: finalRequestParams
                    },
                    success(res) {
                        ctx._raptorReport.monitorReportNetworkSuccess?.({
                            apiPath: path
                        });
                        if (raw) {
                            resolve(res);
                            return;
                        }
                        if (res?.data?.status === 0) {
                            const templateRes = res?.data?.data;
                            resolve(templateRes);
                        }
                        else if (INVALID_CODES.includes(res?.data?.status)) {
                            resolve({
                                uni_status_code: res?.data?.status
                            });
                        }
                        else {
                            const error = new Error(AJAX_ERROR_NAME);
                            error.name = AJAX_ERROR_NAME;
                            error.message = '请求接口异常-code非0';
                            let tags = {};
                            try {
                                tags = {
                                    response: JSON.stringify(res),
                                    params: JSON.stringify(finalRequestParams)
                                };
                            }
                            catch (e) { }
                            ctx._raptorReport.monitorReportLog?.('接口请求异常', error, {
                                level: 'info',
                                category: 'ajaxError',
                                tags
                            });
                            reject(error);
                        }
                    },
                    fail(error) {
                        ctx._raptorReport.monitorReportNetworkFailed?.({
                            apiPath: path
                        });
                        if (typeof error === 'object') {
                            error.name = AJAX_ERROR_NAME;
                            error.message = '请求接口异常-网络异常';
                        }
                        let tags = {};
                        try {
                            tags = {
                                errorInfo: JSON.stringify(error),
                                params: JSON.stringify(finalRequestParams),
                                apiPath: path
                            };
                        }
                        catch (e) { }
                        ctx._raptorReport.monitorReportLog?.('接口请求异常', error, {
                            level: 'info',
                            category: 'ajaxError',
                            tags
                        });
                        reject(error);
                    }
                });
            });
            setRequestStatus(RequestStatus.SUCCESS);
            return response;
        }
        catch (err) {
            setRequestStatus(RequestStatus.ERROR);
            if (err instanceof Error && err.name !== AJAX_ERROR_NAME) {
                let tags = {};
                try {
                    tags = {
                        errorInfo: JSON.stringify(err),
                        params: JSON.stringify(params)
                    };
                }
                catch (e) { }
                ctx._raptorReport.monitorReportLog?.(err.message, err, {
                    level: 'error',
                    category: 'jsError',
                    tags
                });
            }
            return null;
        }
    };
    const getOSType = () => {
        let osType = OSTYPE.ANDROID;
        try {
            const systemInfo = getSystemInfoSync();
            if (systemInfo?.platform?.toLocaleLowerCase()?.includes("harmony"))
                osType = OSTYPE.HARMONY;
            else if (systemInfo?.platform?.toLocaleLowerCase()?.includes("ios"))
                osType = OSTYPE.IOS;
            else if (systemInfo?.platform?.toLocaleLowerCase()?.includes("android"))
                osType = OSTYPE.ANDROID;
        }
        catch (e) {
            ctx._raptorReport.monitorReportLog?.("获取设备类型失败", e, {
                level: 'info',
                category: 'jsError'
            });
            return OSTYPE.OTHER;
        }
        return osType;
    };
    return {
        requestStatus,
        request
    };
}
export var RequestStatus;
(function (RequestStatus) {
    RequestStatus[RequestStatus["LOADING"] = 1] = "LOADING";
    RequestStatus[RequestStatus["SUCCESS"] = 2] = "SUCCESS";
    RequestStatus[RequestStatus["ERROR"] = 3] = "ERROR";
    RequestStatus[RequestStatus["LOADING_MORE"] = 4] = "LOADING_MORE";
    RequestStatus[RequestStatus["LOADING_MORE_SUCCESS"] = 5] = "LOADING_MORE_SUCCESS";
    RequestStatus[RequestStatus["LOADING_MORE_ERROR"] = 6] = "LOADING_MORE_ERROR";
})(RequestStatus || (RequestStatus = {}));
export function getSource() {
    const platformType = getPlatformType();
    switch (platformType) {
        case PlatformType.mtApp:
        case PlatformType.mtAppWebView:
            return Source.MEITUAN_APP;
        case PlatformType.dpApp:
        case PlatformType.dpAppWebView:
            return Source.DIANPING_APP;
        case PlatformType.mtMinaWebview:
            return Source.WECHAT_MEITUAN_MINI;
        case PlatformType.mtHotelMinaWebview:
            return Source.WECHAT_HOTEL_MINI;
        default:
            return Source.MEITUAN_APP;
    }
}
export var Source;
(function (Source) {
    Source[Source["MEITUAN_APP"] = 1] = "MEITUAN_APP";
    // 美团APP
    Source[Source["DIANPING_APP"] = 2] = "DIANPING_APP";
    // 点评APP
    Source[Source["WECHAT_MEITUAN_MINI"] = 3] = "WECHAT_MEITUAN_MINI";
    // 微信美团小程序
    Source[Source["WECHAT_HOTEL_MINI"] = 4] = "WECHAT_HOTEL_MINI";
    // 微信酒店+小程序
    Source[Source["WECHAT_DIANPING_MINI"] = 5] = "WECHAT_DIANPING_MINI"; // 微信点评小程序
})(Source || (Source = {}));
var OSTYPE;
(function (OSTYPE) {
    OSTYPE[OSTYPE["ANDROID"] = 1] = "ANDROID";
    OSTYPE[OSTYPE["IOS"] = 2] = "IOS";
    OSTYPE[OSTYPE["HARMONY"] = 3] = "HARMONY";
    OSTYPE[OSTYPE["OTHER"] = 999] = "OTHER";
})(OSTYPE || (OSTYPE = {}));
